/*
  SAVRA theme.js — small, purpose-specific modules for header scroll state,
  mega menu, mobile drawer, and search overlay. No frameworks; native
  browser behavior preferred throughout (§27).
*/
(function () {
  'use strict';

  function trapFocus(container, onEscape) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handleKeydown(e) {
      if (e.key === 'Escape' && onEscape) {
        onEscape();
        return;
      }
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handleKeydown);
    return function () { container.removeEventListener('keydown', handleKeydown); };
  }

  // Header sticky/scrolled state
  (function headerScroll() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }, { passive: true });
  })();

  // Desktop mega menu
  (function megaMenu() {
    var items = document.querySelectorAll('[data-mega-item]');
    if (!items.length) return;

    var backdrop = document.getElementById('MegaBackdrop');
    function updateBackdrop() {
      if (!backdrop) return;
      var anyOpen = document.querySelector('[data-mega-item].is-open');
      backdrop.classList.toggle('is-open', !!anyOpen);
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.sav-nav-trigger');
      if (!btn) return;

      function close() {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        updateBackdrop();
      }
      function open() {
        if (window.savraCartDrawer) window.savraCartDrawer.close();
        if (window.savraNewsletterOverlay) window.savraNewsletterOverlay.close();
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.sav-nav-trigger');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        updateBackdrop();
      }

      btn.addEventListener('click', function () {
        item.classList.contains('is-open') ? close() : open();
      });
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });

    window.__savraCloseAllMega = function () {
      items.forEach(function (item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('.sav-nav-trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      updateBackdrop();
    };
  })();

  // Mobile drawer
  (function mobileDrawer() {
    var drawer = document.getElementById('MobileDrawer');
    var scrim = document.getElementById('DrawerScrim');
    var trigger = document.getElementById('MobileMenuTrigger');
    var closeBtn = document.getElementById('DrawerClose');
    if (!drawer || !scrim || !trigger || !closeBtn) return;

    var releaseFocusTrap = null;

    function open() {
      if (window.savraCartDrawer) window.savraCartDrawer.close();
      if (window.savraNewsletterOverlay) window.savraNewsletterOverlay.close();
      scrim.hidden = false;
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
      releaseFocusTrap = trapFocus(drawer, close);
    }
    function close() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      trigger.focus();
      if (releaseFocusTrap) releaseFocusTrap();
      setTimeout(function () { scrim.hidden = true; }, 320);
    }

    trigger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);

    document.querySelectorAll('.sav-drawer-acc').forEach(function (acc) {
      acc.addEventListener('click', function () {
        var target = document.getElementById(acc.getAttribute('aria-controls'));
        var isOpen = target.classList.toggle('is-open');
        acc.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    window.__savraCloseDrawer = close;
  })();

  // Search overlay
  (function searchOverlay() {
    var overlay = document.getElementById('SearchDrawer');
    var trigger = document.getElementById('SearchTrigger');
    var drawerTrigger = document.getElementById('DrawerSearchTrigger');
    var closeBtn = document.getElementById('SearchClose');
    var input = document.getElementById('SearchInput');
    if (!overlay || !closeBtn || !input) return;

    var releaseFocusTrap = null;

    function open() {
      if (window.savraCartDrawer) window.savraCartDrawer.close();
      if (window.savraNewsletterOverlay) window.savraNewsletterOverlay.close();
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      input.focus();
      releaseFocusTrap = trapFocus(overlay, close);
    }
    function close() {
      overlay.classList.remove('is-open');
      if (trigger) trigger.focus();
      if (releaseFocusTrap) releaseFocusTrap();
      setTimeout(function () { overlay.hidden = true; }, 320);
    }

    if (trigger) trigger.addEventListener('click', open);
    if (drawerTrigger) {
      drawerTrigger.addEventListener('click', function () {
        if (window.__savraCloseDrawer) window.__savraCloseDrawer();
        open();
      });
    }
    closeBtn.addEventListener('click', close);

    window.__savraCloseSearch = close;
  })();
})();
